// extracted by mini-css-extract-plugin
export default {"container":"account_container__1DvEA","description":"account_description__1eeIa","separator":"account_separator__1KB8K"};